import { FC } from 'react';
import { useLocale } from '@app/core/hooks/useLocale';
import styles from '../../opm-summary-waterfall-erf.module.scss';
import classNames from 'classnames';
import { OpmSampleWaterfallsDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import SvgChevron from '@app/shared/icons/Chevron';
import { ExpandableKeys, ExpandedSectionsState } from './SampleWaterfallOutputsSummary';
import { NOT_APPLICABLE } from './sample-waterfall-column-helpers';
import WaterfallValueCell from './WaterfallValueCell';

type AggregateValueKeys = Omit<OpmSampleWaterfallsDto, 'instruments'>;

interface OtherCalculationsSectionProps {
  waterfallResults: Dictionary<OpmSampleWaterfallsDto>;
  columnKeys: string[];
  onToggle: (key: string) => void;
  expandedSections: ExpandedSectionsState;
}

const SampleWaterfallOutputsOtherCalculationsSection: FC<OtherCalculationsSectionProps> = ({
  waterfallResults,
  columnKeys,
  onToggle,
  expandedSections,
}) => {
  const { l } = useLocale();

  const createRow = (label: string, valueKey: keyof AggregateValueKeys, upper = false) => (
    <tr key={valueKey}>
      <td className={classNames(styles['border-right'])}>{label}</td>
      {columnKeys.map((key) => {
        const result = waterfallResults[key];
        const value = result ? result[valueKey] : NOT_APPLICABLE;
        return (
          <WaterfallValueCell
            key={key}
            value={value}
            valueClassName={
              upper
                ? value === false
                  ? styles['upper-text-value-false']
                  : styles['upper-text']
                : ''
            }
          />
        );
      })}
    </tr>
  );

  return (
    <>
      <tr>
        <th className={styles['section-header']} colSpan={columnKeys.length + 1}>
          {!expandedSections.otherCalculations ? (
            <div className={styles['expand-toggle']}>
              <SvgChevron
                onClick={() => onToggle(ExpandableKeys.OtherCalculations)}
                className={styles[`chevron-collapsed`]}
              />
            </div>
          ) : (
            <div className={styles['expand-toggle']}>
              <SvgChevron
                onClick={() => onToggle(ExpandableKeys.OtherCalculations)}
                className={styles[`chevron-expanded`]}
              />
            </div>
          )}
          {l('_OtherCalculations')}
        </th>
      </tr>
      {expandedSections.otherCalculations && (
        <>
          {createRow(l('_TotalOrdinaryEquityDistributions'), 'totalOrdinaryEquityProceeds')}
          {createRow(l('_OrdinaryEquityCheck'), 'ordinaryEquityCheck', true)}
        </>
      )}
    </>
  );
};

export default SampleWaterfallOutputsOtherCalculationsSection;
